import { z } from 'zod';

import type { ContactDto } from '@/services/ws-crm/src/main/resources/rest-api';

import type { ColumnComponentPropsV2, ColumnV2 } from 'src/types.ts';

export enum ContactsListSearchKey {
  SEARCH = 'search',
  INCLUDE_INACTIVE = 'includeInactive',
}

export const ContactsListSearchParams = z.object({
  [ContactsListSearchKey.SEARCH]: z.string().optional(),
  [ContactsListSearchKey.INCLUDE_INACTIVE]: z.custom<boolean>().optional(),
});

export type ContactsListSearchParams = z.infer<typeof ContactsListSearchParams>;

export type ColumnName = keyof ContactDto | 'account.name' | 'actions';

export type ColumnProps = ColumnComponentPropsV2<ColumnName> & {
  item: ContactDto;
  onUpdateContactState: (updatedContact: ContactDto) => void;
};

export type Column = ColumnV2<ColumnName, ColumnProps>;
